// src/components/EditStrategicPointModal.js
import React from "react";
import axios from "../axiosConfig";
import StrategicPointModal from "./StrategicPointModal";

function EditStrategicPointModal({
  isOpen,
  onClose,
  strategicPoint,       // o location (type STRATEGICPOINT) selecionado na timeline
  transportsessionId,
  onSaved = () => {},   // callback para refresh no parent
}) {
  if (!isOpen) return null;

  // safety: se abrir sem ponto selecionado
  if (!strategicPoint?.id) {
    return (
      <StrategicPointModal
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={() => {}}
        defaultDate={""}
      />
    );
  }

  return (
    <StrategicPointModal
      isOpen={isOpen}
      mode="edit"
      initialData={strategicPoint}
      defaultDate={strategicPoint?.date || ""}
      onClose={onClose}
      onSubmit={async (form) => {
        // PUT do PD strategic point
        await axios.put(`/pickupdeliveries/by-id/${strategicPoint.id}`, {
          ...form,
          strategicPointPurpose:
            String(form.strategicPointPurpose || "GENERAL").toUpperCase() === "FUEL"
              ? "FUEL"
              : "GENERAL",
          transportsessionId,
          type: "STRATEGICPOINT",
        });

        onSaved();
        onClose();
      }}
    />
  );
}

export default EditStrategicPointModal;
